import { SVGProps, useState } from 'react'
import { Link } from 'react-router'

import { combineClassnames } from 'app/common/presentation'

import styles from './Profile.module.scss'

interface WorkspaceMenuItemProps {
  avatar?: JSX.Element
  className?: string
  count?: number
  leftIcon?: React.FC<SVGProps<SVGSVGElement>>
  onClick?: () => void
  rightElement?:
    | {
        active?: React.FC<SVGProps<SVGSVGElement>>
        hovered: React.FC<SVGProps<SVGSVGElement>>
      }
    | JSX.Element
  subtitle?: string
  title: string
  to?: string
}

const WorkspaceMenuItem = ({
  avatar,
  className,
  count,
  leftIcon: LeftIcon,
  onClick,
  rightElement: RightElement,
  subtitle,
  title,
  to,
}: WorkspaceMenuItemProps) => {
  const [hovered, setHovered] = useState(false)

  const renderRightElement = () => {
    if (RightElement) {
      if ('hovered' in RightElement) {
        return RightElement.active ? (
          <RightElement.active />
        ) : hovered ? (
          <RightElement.hovered />
        ) : undefined
      } else {
        return RightElement
      }
    }
  }

  const menuItemContent = (
    <>
      {avatar}
      <div className={styles.option}>
        {LeftIcon && <LeftIcon />}
        <div>
          <div className={styles.title}>{title}</div>
          <div className={styles.subtitle}>{subtitle}</div>
        </div>
      </div>
      {count && <div className={styles.count}>{count}</div>}
      {renderRightElement()}
    </>
  )

  return to ? (
    <Link className={combineClassnames(styles.menuItem, styles.clickable, className)} to={to}>
      {menuItemContent}
    </Link>
  ) : (
    <div
      className={combineClassnames(
        styles.menuItem,
        onClick ? styles.clickable : undefined,
        className,
      )}
      onClick={onClick}
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
    >
      {menuItemContent}
    </div>
  )
}

export default WorkspaceMenuItem
